// src/components/Resume.js
import React from 'react';

const About = () => {
  return (
    <div>
      <h1>About Page</h1>
      <p>This is the About page content.</p>
    </div>
  );
};

export default About;